<template>
  <div class="flex justify-center px-4 text-white">
    <div class="w-full rounded-xl my-2">
      <div class="types-nav">
        <ul class="flex items-center  justify-center gap-2">
          <li
          v-for="tab in tabs"
          :key="tab"
          @click="setTab(tab)"
          :class="[
              'type-pill',
              activeTab === tab && 'active'
          ]"
          >
            <img
                :src="`/wallet/${tab}.svg`"
                class="w-7 h-7 shrink-0"
                alt=""
            />
            <span class="whitespace-nowrap">
                {{ $t(`wallet.${tab}`) || tab }}
            </span>
          </li>
        </ul>
      </div>
      <div class="mt-4 space-y-6">
          <div
            v-for="type in transactionsTypes"
            :key="type.id"
          >
            <div class="flex items-center justify-between mb-3 px-2">
              <p class="text-sm font-semibold text-white/80">
                {{ type.name }}
              </p>
              <span class="text-xs text-white/50">
                {{ type.items.length }}
              </span>
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div
                v-for="item in type.items"
                :key="item.id"
                class="payment-card"
                @click="openDepositModal(type, item)"
              >
                <div class="logo-wrap mb-3">
                    <img
                        :src="item.logo"
                        class="logo-img"
                        alt=""
                    />
                </div>
                <div class="text-xs text-white/80 space-y-1">
                  <div>{{t('wallet.min')}}: <span class="font-semibold">{{ item.min }} </span></div>
                  <div>{{t('wallet.max')}}: <span class="font-semibold">{{ item.max }}</span></div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <DepositModal ref="depositModal" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import DepositModal from '@/views/(app)/Partials/DepositModal.vue';

const depositModal = ref()
const { t } = useI18n()
const tabs = ['deposit', 'withdraw']
const activeTab = ref('deposit')
const transactionsTypes = [
  {
    id: 1,
    name: 'BankTransfer',
    items: [
      { id: 1, logo: '/payment/bank1.png', min: 50, max: 50000 },
      { id: 2, logo: '/payment/bank2.png', min: 5000, max: 20000 },
      
    ]
  },
  // {
  //   id: 2,
  //   name: 'Crypto',
  //   items: [
  //     { id: 3, logo: '/payment/crypto1.png', min: 3000, max: 4000 },
  //     { id: 4, logo: '/payment/crypto2.png', min: 1000, max: 8000 },
  //     { id: 5, logo: '/payment/crypto3.jpeg', min: 100, max: 7000 },
  //   ]
  // }
]
const setTab = async (type) => {
  activeTab.value = type;
}
const openDepositModal = (type, item) => {
  depositModal.value.openModal({
    action: activeTab.value, 
    type,
    item
  })
}
</script>
<style scoped>
.types-nav {
  @apply my-2 p-2 rounded-2xl;
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--color-primary1) 35%, transparent),
    color-mix(in srgb, var(--color-primary1) 15%, transparent)
  );
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.12),
    0 8px 30px rgba(0,0,0,0.35);
}
.type-pill {
  @apply flex items-center gap-2 px-3 py-1.5 rounded-xl cursor-pointer text-white/80 text-sm font-semibold transition-all duration-200;
  background: color-mix(in srgb, var(--color-primary1) 12%, transparent);
}
.type-pill:hover {
  background: color-mix(in srgb, var(--color-primary1) 22%, transparent);
}
.type-pill.active {
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--color-primary1) 90%, white 5%),
    var(--color-primary1)
  );
  color: #fff;
  box-shadow:
    0 6px 18px rgba(0,0,0,0.45),
    inset 0 1px 0 rgba(255,255,255,0.25);
}
.type-pill.active span {
  font-weight: 700;
}
.payment-card {
  @apply rounded-xl p-3 cursor-pointer transition-all duration-200;
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--color-primary1) 35%, transparent),
    color-mix(in srgb, var(--color-primary1) 15%, transparent)
  );
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.12),
    0 6px 18px rgba(0,0,0,0.35);
}

.payment-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 10px 26px rgba(0,0,0,0.45),
    inset 0 1px 0 rgba(255,255,255,0.18);
}
.logo-wrap {
  @apply bg-white rounded-xl flex items-center justify-center;
  padding: 4px;
  height: 44px;
}

.logo-img {
  max-height: 30px;
  max-width: 100%;
  object-fit: contain;
}
</style>